export enum RankingType {
  WeightedRanking = 'weighted_ranking',
  TieBreakingSorting = 'tie_breaking',
}
